import { Link } from "react-router-dom";
import PublicHeader from "../components/PublicHeader";
import PublicFooter from "../components/PublicFooter";
import { ArrowRightIcon, Eyebrow, Fleuron } from "../components/design";

export default function NotFound() {
  return (
    <div
      className="paper-bg"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <PublicHeader />
      <main
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "60px 22px 80px",
        }}
      >
        <div style={{ maxWidth: 460, textAlign: "center" }}>
          <Eyebrow>Fehler 404</Eyebrow>
          <div
            style={{
              fontFamily: "var(--f-display)",
              fontStyle: "italic",
              fontWeight: 400,
              fontSize: 96,
              lineHeight: 1,
              color: "var(--oxblood)",
              margin: "8px 0 14px",
              letterSpacing: "-0.02em",
            }}
          >
            404
          </div>
          <h1
            style={{
              fontFamily: "var(--f-display)",
              fontStyle: "italic",
              fontWeight: 400,
              fontSize: 28,
              lineHeight: 1.15,
              color: "var(--ink)",
              margin: "0 0 12px",
            }}
          >
            Diese Seite konnten wir nicht finden.
          </h1>
          <p
            style={{
              fontFamily: "var(--f-body)",
              fontSize: 16,
              lineHeight: 1.5,
              color: "var(--ink-soft)",
              margin: "0 0 22px",
            }}
          >
            Vielleicht ist sie umgezogen — oder hat es nie gegeben.
          </p>
          <Fleuron style={{ margin: "0 auto 20px", maxWidth: 260 }} />
          <Link
            to="/"
            className="btn-primary"
            style={{ display: "inline-flex" }}
          >
            Zurück zur Startseite
            <ArrowRightIcon />
          </Link>
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
